import React, { useContext, useRef, useEffect } from 'react';
import { LoginContext } from '../../contexts/LoginContext';
import ViewPortGridWrapper from '../../containers/ViewPortGridWrapper';
import { Button, makeStyles, TextField } from '@material-ui/core';
import { commonFilter } from '../../constants/StyleConstants';
import DefaultUnrederedGridMessage from '../../containers/DefaultUnrenderedGridMessage';

import ExcludedPurchaseOrdersGrid from './ExcludedCertificatePurchaseOrdersGrid';
import useExcludedCertificatePurchaseOrdersPresenter from './ExcludedCertificatePurchaseOrdersPresenter';

const useStyles = makeStyles(theme => ({
  ...commonFilter,
}));

const Filters = ({ filtersProps }) => {
  const classes = useStyles();
  const {
    purchaseOrderCode,
    setPurchaseOrderCode,

    validateAndSearch,
    cleanFilters,
    
  } = filtersProps;


  return (
    <div className={classes.filters}>
      
      <TextField
        style={{ width: 200 }}
        margin="dense"
        id="code"
        label="Nro. de pedido de compra"
        onChange={(e) => setPurchaseOrderCode(e.target.value)}
        value={purchaseOrderCode}
      />
 
      
      <div className={classes.filtersActionButton}>
        <Button variant="outlined" color="primary" onClick={validateAndSearch}>
          Filtrar
        </Button>
        <Button variant="outlined" color="secondary" onClick={cleanFilters}>
          Limpiar
        </Button>
      </div>
    </div>
  );
};


const ExcludedPurchaseOrders = () => {
  const tableRef = useRef();
  const { firstLoad, rows, loading, gridFunctions, ...filtersProps } = useExcludedCertificatePurchaseOrdersPresenter(tableRef);

  return (
    <ViewPortGridWrapper>
      <Filters filtersProps={filtersProps} />
      <DefaultUnrederedGridMessage render={!firstLoad}>
        <ExcludedPurchaseOrdersGrid data={rows} loading={loading} tableRef={tableRef} {...gridFunctions} />
      </DefaultUnrederedGridMessage>
    </ViewPortGridWrapper>
  );
};

export default ExcludedPurchaseOrders;